export class RefundPaymentDto {
  constructor(dto) {
    this.id = dto.id;
  }
}
